module.exports = {
          srcSet: __webpack_public_path__ + "f0e9a5e4657b9fa47cb472c58d61e853-821.png"+" 821w",
          images:[ {path: __webpack_public_path__ + "f0e9a5e4657b9fa47cb472c58d61e853-821.png",width: 821,height: 487}],
          src: __webpack_public_path__ + "f0e9a5e4657b9fa47cb472c58d61e853-821.png",
          toString:function(){return __webpack_public_path__ + "f0e9a5e4657b9fa47cb472c58d61e853-821.png"},
          
          width: 821,
          height: 487
        }